import { TemplateTypeCode } from './template';

export enum DocumentTypeCode {
  clinicalReferral = 'document.type.clinical-referral',
  homeBasedCareReferral = 'document.type.home-based-care-referral',
  motivationMedicalDevice = 'document.type.motivation-medical-device',
  createScript = 'document.type.create-script',
}

export const DocumentTypeCodeDescription: Record<DocumentTypeCode, string> = {
  [DocumentTypeCode.clinicalReferral]: 'Clinical referral',
  [DocumentTypeCode.homeBasedCareReferral]: 'Home-based care referral',
  [DocumentTypeCode.motivationMedicalDevice]: 'Motivation for medical device',
  [DocumentTypeCode.createScript]: 'Create medication script',
};

export const DocumentTypeToTemplateType: Record<
  DocumentTypeCode,
  TemplateTypeCode
> = {
  [DocumentTypeCode.clinicalReferral]: TemplateTypeCode.ClinicalReferral,
  [DocumentTypeCode.homeBasedCareReferral]:
    TemplateTypeCode.HomeBasedCareReferral,
  [DocumentTypeCode.motivationMedicalDevice]:
    TemplateTypeCode.MotivationMedicalDevice,
  [DocumentTypeCode.createScript]: TemplateTypeCode.CreateScript,
};
